/**
 * Newsletter signup form — shows validation errors as red text under the
 * field (matching the contact form) instead of the browser's native
 * tooltip bubble. Shared by the newsletter section and the footer's
 * newsletter bar/column (all use snippets/newsletter-form.liquid), keyed
 * off the common .spi_newsletter-form class so one script covers every
 * instance on the page.
 *
 * Validation is re-run explicitly on every submit attempt and gates the
 * submit with preventDefault, so it never depends on the browser's own
 * constraint-validation state staying in sync across repeated clicks.
 *
 * The listener runs in the CAPTURE phase and calls stopImmediatePropagation()
 * on a blocked attempt. Shopify auto-attaches its own hCaptcha submit
 * handler to any form with form_type "contact" or "customer" (this one is
 * "customer"), which can run its check asynchronously and call
 * form.submit() directly once it resolves — that bypasses both the
 * `submit` event and constraint validation entirely, which is what let an
 * empty second attempt through. Capturing first and stopping propagation
 * means our check always runs before that handler gets a chance to start.
 */
(function () {
  function initForm(form) {
    if (form.dataset.newsletterValidationInit === '1') return;
    form.dataset.newsletterValidationInit = '1';

    var input = form.querySelector('input[type="email"]');
    if (!input) return;

    var errorEl = input.id
      ? form.querySelector('.spi_newsletter-field-error[data-error-for="' + input.id + '"]')
      : null;

    // Take over validation entirely so a stale native validity state can't
    // let a later submit through.
    form.setAttribute('novalidate', 'novalidate');

    var requiredMessage = input.dataset.errorRequired || '';
    var invalidMessage = input.dataset.errorInvalid || '';

    function setError(message) {
      if (errorEl) errorEl.textContent = message || '';
      input.classList.toggle('spi_input-error', !!message);
      if (message) input.setAttribute('aria-invalid', 'true');
      else input.removeAttribute('aria-invalid');
    }

    function validate() {
      var value = input.value.trim();
      if (value === '') {
        setError(requiredMessage);
        return false;
      }
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        setError(invalidMessage);
        return false;
      }
      setError('');
      return true;
    }

    input.addEventListener('blur', validate);
    input.addEventListener('input', function () {
      if (input.classList.contains('spi_input-error')) validate();
    });

    // Registered on document with capture:true — not on the form itself —
    // so it runs during the downward capture pass, before the event ever
    // reaches the form (and any listener attached there, at any phase).
    document.addEventListener(
      'submit',
      function (e) {
        if (e.target !== form) return;
        if (!validate()) {
          e.preventDefault();
          e.stopImmediatePropagation();
          input.focus();
        }
      },
      true
    );
  }

  function initAll(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('.spi_newsletter-form').forEach(initForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target || document);
  });
})();
